import React from 'react';
import "./documentUpload.scss";
import { connect } from "react-redux";
import YorLoanDetails from "../AddBankDetails/yourLoanDetails";
import ActionRequired from "./ActionRequired/actionRequired";
import { getOfferPreFilledData } from "../../selectors";
import { uploadRequiredDocs } from "../../actions/crossSellApplicationActions";

export class DocumentUpload extends React.Component {
  constructor(props) {
    super(props);
    this.state= {
      showStatus: true
    };
  }

  render() {
    return(
      <div className="row">
        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-5 padding-xs-5">
          <div className="row">
            <YorLoanDetails showStatus={this.state.showStatus} offerPreFilled={this.props.offerPreFilled} />
          </div>
        </div>
        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-7 padding-xs-5">
          <div className="row">
            <ActionRequired {...this.props}/>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return { offerPreFilled: getOfferPreFilledData(state) };
};
const mapDispatchToProps={ uploadRequiredDocs: uploadRequiredDocs };

export default connect(mapStateToProps, mapDispatchToProps)(DocumentUpload);


